
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface StatusFieldProps {
  status: string;
  onStatusChange: (value: string) => void;
}

export const StatusField = ({ status, onStatusChange }: StatusFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="status">Status</Label>
      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger className="h-14">
          <SelectValue placeholder="Select status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="pending_cancellation">Pending Cancellation</SelectItem>
          <SelectItem value="cancelled">Cancelled</SelectItem>
          <SelectItem value="reinstated">Reinstated</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
